/**
 * Return the URL to the friendbuy public REST API
 * @param awsAccountId The AWS account ID
 */
export function getPublicApiUrl(awsAccountId?: string): string {
  switch (awsAccountId) {
    case "644084073510": // production
      return "https://public.fbot.me";
    case "627208980326": // sandbox
      return "https://public.fbot-sandbox.me";
    case "913709512847": // staging
      return "https://public.fbot-staging.me";
    case "755386480951": // qa
      return "https://public.fbot-qa.me";
    case "266256754960": // applause
      return "https://public.fbot-applause.me";
    default:
      return `http://public.fbot-sandbox.me`;
  }
}
